<template>
  <div class="home">
    <section class="banner">
      <div class="banner-box">
        <div class="banner-text">
          <div class="slogan opacity-0 animate__animated" data-animate="animate__fadeInLeftBig">专为科技金融打造的智能决策引擎</div>

          <div class="title opacity-0 animate__animated" data-animate="animate__fadeInLeftBig">
            <span>科技企业</span>
            <span>价值发现</span>
          </div>

          <div class="sub-title opacity-0 animate__animated" data-animate="animate__fadeInRightBig">
            专注产业科技金融创新AI应用，致力于为银行、投资机构及证券公司<br />
            提供覆盖产业科技金融全链路的智能分析与决策参考<br />
          </div>

          <div class="btn-container opacity-0 animate__animated" data-animate="animate__fadeInUp">
            <div class="exp-btn" @click="toRegister()">
              <span>申请体验</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="service-scene">
      <div class="text opacity-0 animate__animated" data-animate="animate__fadeInUp">
        <div class="title">服务场景</div>
        <div class="sub-title">三大核心场景，助力科技金融与产业创新决策</div>
      </div>
      <div class="content opacity-0 animate__animated" data-animate="animate__fadeInUp">
        <div class="scene-box">
          <div class="scene-item" v-for="(its, index) in sceneList" :key="index">
            <img :src="its.img" width="42">
            <div class="title">{{ its.title }}</div>
            <div class="desc">{{ its.desc }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="product">
      <div class="text opacity-0 animate__animated" data-animate="animate__fadeInUp">
        <div class="title">
          <span>专为科技金融打造的</span>
          <span>智能决策引擎</span>
        </div>
      </div>
      <div class="content opacity-0 animate__animated" data-animate="animate__fadeInUp">
        <div class="product-box">
          <div class="product-item" v-for="(item, index) in productList" :key="index" :style="{ backgroundImage: `url(${item.bgUrl})` }">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
            <div class="product-tags">
              <span v-for="(its, idx) in item.tags" :key="idx">{{ its }}</span>
            </div>
            <div class="btn-container">
              <div class="exp-btn" @click="toPage(item.link)">
                <span>查看详情</span>
                <i class="iconfont icon-youjiantou-xianxing"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="data-base">
      <div class="text opacity-0 animate__animated" data-animate="animate__fadeInUp">
        <div class="title">高质量的产业科技金融数据底座</div>
      </div>
      <div class="content opacity-0 animate__animated" data-animate="animate__fadeInUp">
        <div class="data-base-box">
          <div class="data-base-item" v-for="(its, index) in dataList" :key="index">
            <div class="title">{{ its.title }}</div>
            <div class="sub-title">{{ its.subTitle }}</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { useAnimate } from '@/hooks'

export default {
  name: 'HomeV2',
  data () {
    return {
      sceneList: [
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_银行.png',
          title: '银行',
          desc: '多维度评估科技企业价值，预测成长潜力与风险，赋能银行贷前营销、贷中授信与贷后风控全链路'
        },
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_投资机构.png',
          title: '投资机构',
          desc: '赛道机会发现，自动化分析产业链结构，识别高成长赛道与关键节点，辅助投资机构发现产业投资机会'
        },
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_服务创新.png',
          title: '服务创新',
          desc: '区域创新资源洞察，透视区域产业布局与创新资源分布，助力区域创新生态建设'
        }
      ],
      productList: [
        {
          title: '瞰见',
          desc: '从产业链全景穿透到区域集群竞争力研判，为银行提供"该产业能不能进、从哪切入"的战略依据，以及差异化经营的区域作战地图。',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_瞰见_产品.png',
          tags: ['产业图谱', '区域洞察', '链式分析', '差异决策'],
          link: '/aerialView'
        },
        {
          title: '深眸',
          desc: '多维穿透科技企业价值，穿透成长性与劣变风险，让营销有靶向，审批决策有依据。',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_深眸_产品.png',
          tags: ['企业评估', '尽调赋能', '成长预判', '风险预警'],
          link: '/patE'
        },
        {
          title: '点睛投研',
          desc: '专为投资场景打造的AI科技企业成长性评测产品，30秒看评级，5分钟完成初筛，让投资决策更快、更准。',
          bgUrl: 'https://images.zzt.com.cn/cdn_file/zst-official/bg_视金_产品.png',
          tags: ['项目初筛', '竞品对比', '立项审批', '投后追踪'],
          link: '/goldSight'
        }
      ],
      dataList: [
        { title: '2万+', subTitle: '产业集群' },
        { title: '1000+', subTitle: '产业链' },
        { title: '60万+', subTitle: '融资事件' },
        { title: '2.08亿+', subTitle: '专利' },
        { title: '200万+', subTitle: '科技人才' },
        { title: '50万+', subTitle: '科技成果项目' }
      ]
    }
  },
  methods: {
    toPage (link) {
      window.scrollTo(0, 0, 'smooth')
      this.$router.push(link)
    },
    toRegister () {
      this.toPage('/register')
    }
  },
  mounted () {
    const { animate } = useAnimate()
    const html = document.documentElement
    if (html.scrollTop === 0) {
      animate()
      return
    }
    window.scrollTo({ top: 0, behavior: 'smooth' })
    const onScroll = () => {
      if (html.scrollTop === 0) {
        document.removeEventListener('scroll', onScroll)
        animate()
      }
    }
    document.addEventListener('scroll', onScroll)
  }
}
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  min-width: $container-width;
}

section {
  .content {
    width: $container-width;
    margin: 0 auto;
  }

  .title {
    @include Text(36px, 500, 50px, #111111, 'PingFangSC-Medium');
  }

  .sub-title {
    margin-top: Translate(4px);
    @include Text(16px, 400, 30px, #666666, 'PingFangSC-Regular');
  }
}

.btn-container {
  display: flex;
  justify-content: space-between;

  .exp-btn {
    @include Button(180px, 54px, transparent, 16px, #fff);
    background-image: linear-gradient(90deg, #0058FF 0%, #12A4FA 100%);
    border-radius: Translate(10px);

    &:hover {
      opacity: 0.8;
    }

    i {
      font-size: Translate(22px);
      margin-left: Translate(6px);
      transition: transform 0.15s ease-in;
      @include ChevronIconAnimation();
    }
  }
}

.banner {
  position: relative;
  height: Translate(600px);
  background: url("https://images.zzt.com.cn/cdn_file/zst-official/bg_首页_header.png") no-repeat;
  background-position: center center;
  background-size: cover;
  margin: 0 auto;

  &-box {
    width: $container-width;
    margin: 0 auto;
    position: relative;
    height: 100%;
  }

  &-text {
    text-align: left;

    .slogan {
      position: absolute;
      top: Translate(150px);
      left: 0;
      padding: Translate(4px) Translate(19px);
      background-image: linear-gradient(270deg, #EAF1FE 0%, #D6F4F7 100%);
      border-radius: Translate(22.5px);
      @include Text(18px, 500, 25px, #333333, 'PingFangSC-Medium');
    }

    .title {
      position: absolute;
      top: Translate(192px);
      left: 0;
      display: flex;
      gap: Translate(6px);
      @include Text(60px, 600, 84px, #111111, 'PingFangSC-Semibold');

      span:last-child {
        @include GradientText();
      }
    }

    .sub-title {
      width: Translate(479px);
      position: absolute;
      top: Translate(284px);
      left: 0;
      @include Text(16px, 400, 26px, #333333, 'PingFangSC-Regular');
    }

    .btn-container {
      position: absolute;
      top: Translate(376px);
      left: 0;
    }
  }
}

.service-scene {
  background: #FFFFFF;
  padding-top: Translate(86px);
  padding-bottom: Translate(107px);

  .scene-box {
    display: flex;
    gap: Translate(24px);
    margin-top: Translate(24px);

    .scene-item {
      display: flex;
      flex-direction: column;
      width: Translate(384px);
      background-color: #F5F7FA;
      padding: Translate(38px) Translate(16px) Translate(16px);
      border-radius: Translate(14px);
      box-sizing: border-box;
      text-align: left;
      transition: all 0.3s ease-in;

      &:hover {
        transform: translateY(Translate(-2px));
        box-shadow: 0 4px 20px 0 rgba(166, 166, 166, 0.2);
      }

      .title {
        margin-top: Translate(18px);
        @include Text(24px, 500, 34px, #111111, 'PingFangSC-Medium');
      }

      .desc {
        flex: 1;
        margin-top: Translate(18px);
        background-color: #FFFFFF;
        padding: Translate(16px) Translate(18px);
        border-radius: Translate(8px);
        @include Text(16px, 400, 24px, #666666, 'PingFangSC-Regular');
      }
    }
  }
}

.product {
  background: url("https://images.zzt.com.cn/cdn_file/zst-official/bg_产品矩阵.png") no-repeat;
  background-position: center center;
  background-size: cover;
  padding-top: Translate(86px);
  padding-bottom: Translate(109px);

  .text {
    .title {
      display: flex;
      justify-content: center;
      gap: Translate(5px);
      color: #FFFFFF;

      span:last-child {
        @include GradientText();
      }
    }
  }

  .product-box {
    display: flex;
    justify-content: center;
    gap: Translate(25px);
    margin-top: Translate(35px);

    .product-item {
      width: Translate(384px);
      min-height: Translate(424px);
      padding: Translate(32px) Translate(20px) 0;
      background-position: center center;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-color: #FFFFFF;
      box-sizing: border-box;
      text-align: left;
      border-radius: Translate(10px);
      transition: all 0.3s ease-in;

      &:hover {
        transform: translateY(Translate(-2px));
        box-shadow: 4px 10px 30px -4px rgba(255, 255, 255, 0.8);
      }

      .title {
        @include Text(24px, 500, 33px, #111111, 'PingFangSC-Medium');
      }

      .desc {
        min-height: Translate(72px);
        margin-top: Translate(10px);
        @include Text(16px, 400, 24px, #333333, 'PingFangSC-Regular');
      }

      .product-tags {
        display: flex;
        flex-wrap: wrap;
        gap: Translate(8px);
        margin-top: Translate(24px);

        span {
          @include Tag();
        }
      }

      .btn-container {
        margin-top: Translate(105px);
      }
    }
  }
}

.data-base {
  background: url("https://images.zzt.com.cn/cdn_file/zst-official/bg_金融数据.png") no-repeat;
  background-position: center center;
  background-size: cover;
  padding-top: Translate(133px);
  padding-bottom: Translate(151px);

  .text {
    width: $container-width;
    margin: 0 auto;
    text-align: left;

    .title {
      font-weight: 600;
      font-family: 'PingFangSC-Semibold';
    }
  }

  .data-base-box {
    width: Translate(666px);
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: Translate(18px);
    margin-top: Translate(28px);

    .data-base-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: Translate(110px);
      background: #ffffffb3;
      border-radius: Translate(10px);
      transition: all 0.3s ease-in;

      &:hover {
        transform: translateY(Translate(-2px));
        box-shadow: 0 4px 8px 0 rgba(166, 166, 166, 0.1);
      }

      .title {
        @include Text(28px, 600, 40px, #0058FF, 'PingFangSC-Semibold');
      }

      .sub-title {
        @include Text(16px, 500, 22px, #111111, 'PingFangSC-Medium');
      }
    }
  }
}
</style>
